import { Box, Typography } from '@mui/material';

type Props = {
  label: string;
  values: React.ReactNode;
};

export default function SectionComponentRow({ label, values }: Props) {
  return (
    <Box className="section-row" width="100%">
      <Typography variant="h4">{label}</Typography>
      {values}
    </Box>
  );
}
